import {
  EscHotKeyIcon,
  ReturnHotKeyIcon,
} from '@modules/common/components/HotKeyIcons';
import { useCreateCollectionAndAddFeedback } from '@modules/feedback/hooks';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Stack,
  TextField,
} from '@mui/material';
import { FormEvent, useState } from 'react';

interface AddToNewCollectionDialogProps {
  onClose: () => void;
}

export const AddToNewCollectionDialog = ({
  onClose,
}: AddToNewCollectionDialogProps) => {
  const [nameOfCollection, setNameOfCollection] = useState('');
  const [descriptionOfCollection, setDescriptionOfCollection] = useState('');

  const { createCollectionAndAddFeedback, isLoading } =
    useCreateCollectionAndAddFeedback({
      nameOfCollection,
      descriptionOfCollection,
      feedbackID: '1',
    });

  const onCreateNewCollection = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await createCollectionAndAddFeedback();
    onClose();
  };

  return (
    <Dialog
      open
      fullWidth
      maxWidth="sm"
      PaperProps={{
        elevation: 1,
      }}
      onKeyDown={(event) => {
        // fix modal closing on tab key press
        if (event.key === 'Tab') {
          event.stopPropagation();
        }
      }}
    >
      <Box component="form" onSubmit={onCreateNewCollection}>
        <DialogTitle>Add to a new Collection</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText sx={{ mb: 3 }}>
            Create new collection to save the selected feedback in it
          </DialogContentText>

          <Stack spacing={2}>
            <TextField
              value={nameOfCollection}
              onChange={(event) => {
                event.stopPropagation();
                setNameOfCollection(event.target.value);
              }}
              id="name"
              name="name"
              label="Enter Collection Name"
              variant="outlined"
              type="text"
              required
              autoComplete="off"
              fullWidth
            />
            <TextField
              label="Describe the purpose of this collection"
              value={descriptionOfCollection}
              onChange={(event) => {
                event.stopPropagation();
                setDescriptionOfCollection(event.target.value);
              }}
              id="description"
              name="description"
              multiline
              rows={4}
              required
              autoComplete="off"
            />
          </Stack>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={onClose}
            variant="outlined"
            endIcon={<EscHotKeyIcon />}
          >
            Cancel
          </Button>
          <LoadingButton
            loading={isLoading}
            type="submit"
            variant="contained"
            endIcon={<ReturnHotKeyIcon />}
            disabled={!nameOfCollection || !descriptionOfCollection}
          >
            Create Collection
          </LoadingButton>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
